/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createTranspose } from '../../factoriesAny.js';
export var transposeDependencies = {
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createTranspose: createTranspose
};